// CategoriesScreen.jsx
import React, { useContext, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const categories = [
  { id: 'playlists', title: 'SPNLISTS' },
  { id: 'songs',     title: 'DATS'     },
  { id: 'artists',   title: 'Artists'  },
  { id: 'genres',    title: 'Genres'   },
];

export default function CategoriesScreen () {
  const navigate                       = useNavigate();
  const { musicVideos, userWallet, assetsSummary, library, currentUser, purchasedMovies }  = useContext(AppContext);

  const albumsPurchased = library.filter(item => item.isAlbum);
  const singlesPurchased = library.filter(item => !item.isAlbum && !item.isVideo && !item?.isBeat);
  const videosPurchased = library.filter(item => item.isVideo);
  const beatsPurchased = library.filter(item => item?.isBeat);

  const videosInLibrary = library.filter(item => item.isVideo);

  const hasAlbums = albumsPurchased.length > 0 || (currentUser?.albums && currentUser.albums.length > 0);
  const hasSingles = singlesPurchased.length > 0 || (currentUser?.singles && currentUser?.singles.length > 0);
  const hasVideos = 
  videosInLibrary.length > 0;
  const hasBeats = beatsPurchased.length > 0 || (currentUser?.beats && currentUser.beats.length > 0);
  const hasSongs = hasAlbums || hasSingles;
  const hasAnyMedia = hasSongs || hasVideos || hasBeats;
  const hasMovies = purchasedMovies && purchasedMovies.length > 0;


const songsLibraryItems = Array.isArray(library)
  ? library.filter(
      item =>
        !item?.isVideo &&          // skip videos
        !item?.isBeat  &&          // skip beats
        item?.isNFT !== true       // skip NFTs
    )
  : [];
const hasSongsCategory = songsLibraryItems.length > 0;

// WITH
const albumsLibraryItems = Array.isArray(library)
  ? library.filter(
      item =>
        !item?.isVideo &&
        !item?.isBeat &&
        item?.isAlbum === true &&
        item?.isNFT !== true
    )
  : [];
const hasAlbumsCategory = albumsLibraryItems.length > 0;



  let dynamicCategories = [];




  dynamicCategories.push({ id: 'Playlists', title: 'SPNLISTS' });

      dynamicCategories.push({ id: 'Favorites', title: 'Favorites' });

  if (hasSongs) {
    dynamicCategories.push({ id: 'DATS', title: 'DATS' });
  }

  if (hasSongsCategory) {
    dynamicCategories.push({ id: 'Songs', title: 'Songs' });
  }  

      if (hasVideos) {
    dynamicCategories.push({ id: 'Videos', title: 'Videos' });
  }  

  if (hasAlbumsCategory) {
    dynamicCategories.push({ id: 'Albums', title: 'Albums' });
  }  


  if (hasAnyMedia) {
    dynamicCategories.push({ id: 'Artists', title: 'Artists' });
  }


  if (hasAnyMedia) {
    dynamicCategories.push({ id: 'Genres', title: 'Genres' });
  }

  /* ------- liked DATS ------- */
  const likedAssets = useMemo(()=>{
    const likedIds = userWallet?.likes || [];
    return assetsSummary?.filter(a => likedIds.includes(a.id));
  },[userWallet, assetsSummary]);

  const getFloorPrice = useCallback(asset=>{
    const fs = (asset.editions || []).filter(ed => ed.isForSale);
    if (!fs.length) return 0;
    return fs.reduce((low,ed)=> ed.price < low ? ed.price : low , fs[0].price);
  },[]);

  const goTo            = path => navigate(path);
  const handleCategory   = cat  => goTo(`/library/${cat}`);
  const handleDatClick   = dat  => goTo(`/dat/${dat.id}`, { state:{ dat } });

  return (
    <div style={s.page}>
      <img src={require('./assets/BlankBG.png')} style={s.bg} alt="" />
      <div style={s.container}>
        <div style={s.headerContainer}>
          <h2 style={s.headerText}>LIBRARY</h2>
        </div>
        <ul style={s.scroll}>


          {/* ---- library categories ---- */}
          {dynamicCategories.map(c=>(
            <li key={c.id} style={s.listItem}>
              <button onClick={()=>handleCategory(c.id)} style={s.button}>
                <div style={s.row}>
                  <img src={require('./assets/dot.png')} alt="" style={s.bullet}/>
                  <span style={s.rowText}>{c.title}</span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

/* ---------- styles ---------- */
const s = {
  page:        { position:'relative', height:'100vh', display:'flex', flexDirection:'column', alignItems:'center' },
  bg:          { position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', zIndex:0 },
  container:   { width:'100%', maxWidth:'100vw', zIndex:1, height:'calc(100vh - 18vh)', display:'flex', flexDirection:'column', alignItems:'center' },

  /* header */
  header:      { padding:'1vh 0', width:'100%', display:'flex', justifyContent:'center' },
  headerText:  { color:'#fff', fontSize:'2.6vh', fontWeight:'bold', margin:0 },

  /* list */
  scroll:      { listStyle:'none', marginTop:'0px', padding:0, width:'100%', height:'130%', overflowY:'auto' },

  /* liked section */
  likedHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'0vh 2vw 0' },
  likedTitle:  { color:'#fff', fontSize:'2.2vh', fontWeight:'bold',  },
  seeAll:      { border:0, background:'transparent', color:'#62fbfa', fontSize:'1.6vh', cursor:'pointer',  },

  cardStrip:   { display:'flex', gap:'1.8vw', padding:'1vh 0 1vh 2vw', overflowX:'auto' },

  /* DAT card */
  card:        {
    flex:'0 0 auto',
    width:'clamp(140px, 34vw, 170px)',
    aspectRatio:'3/4',
    position:'relative',
    border:0, padding:0,
    borderRadius:'12px',
    overflow:'hidden',
    cursor:'pointer',
    background:'transparent',
  },
  cardBg:      { position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' },

  art:         {
    position:'absolute', top:0, left:'4px',
    width:'95%', height:'70%',
    objectFit:'cover',
    borderRadius:'10px 10px 0 0',
    zIndex:1,
  },

  meta:        {
    position:'absolute', bottom:'16px', left:0, right:0,
    display:'flex', flexDirection:'column', padding:'0 1vw',
    textAlign:'left', zIndex:2,
  },
  datName:     {
    color:'#fff', fontSize:'15px', whiteSpace:'nowrap',
    overflow:'hidden', textOverflow:'ellipsis',
     fontWeight:400,
  },
  price:       { color:'#fff', fontSize:'15px',  fontWeight:400 },

  likePrompt:  { padding:'2vh 0 1vh 2vw' },
  promptBtn:   { border:0, background:'transparent', color:'#62fbfa', fontSize:'2.1vh', fontWeight:'bold', cursor:'pointer', },

  /* categories */
  listItem:    { marginBottom:'1vh', marginLeft: '20px' },
  button:      { width:'100%', background:'transparent', border:0, padding:'1vh', textAlign:'left', cursor:'pointer' },
  row:         { display:'flex', alignItems:'center' },
  bullet:      { width:'2vh', height:'2vh', marginRight:'1vw' },
  rowText:     { color:'#fff', fontSize:'2.4vh', fontWeight:'bold', },
    headerContainer: {
    display: 'flex',
    marginLeft: '60px',
    marginTop: '20px',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '0.8vh 0', // Add padding to the header container
    width: '100%',
    backgroundColor: 'transparent', // Ensure the background is transparent
    zIndex: 10,
  },
  headerText: {
    color: 'white',
    fontSize: '2.5vh',
      margin: 0,
    fontWeight: 'bold',
    textAlign: 'center', // Center the text horizontally
  },
};
